import { render, staticRenderFns } from "./course_form.vue?vue&type=template&id=4d16b858&scoped=true&"
import script from "./course_form.vue?vue&type=script&lang=ts&"
export * from "./course_form.vue?vue&type=script&lang=ts&"
import style0 from "./course_form.vue?vue&type=style&index=0&id=4d16b858&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d16b858",
  null
  
)

export default component.exports